<!--
 FIXME: 将来的に BoxListAlert と統合して、オプションで色を変えられるようにする
 コンポーネント名を BoxList にしたいが、利用箇所が多く別途対応した方が良さそうなので一旦 Pending にしている。
 -->
<template>
  <div class="box-list-attention">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.box-list-attention {
  font-size: 1rem;
  line-height: 1.6;
  padding: 8px;
  box-sizing: border-box;
  text-align: left;
  max-width: 100%;
  border-radius: 4px;
  color: $gray-1;
  background-color: $gray-3;
  border: 1px solid $gray-2;
}
</style>
